import { apiResponse } from 'api'

export const errorObj = (error) => {
  let obj = apiResponse()
  obj.resData = error?.response?.data
  obj.resStatus = error?.response?.status
  return obj
}
